import React from 'react';
import axios from 'axios';

class Persona extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount(){}

  render(){
    const {persona, seleccionar, seleccionado} = this.props;
    return(
      <div
        style={{
          width:'100%', padding:10, cursor:'pointer',
          display:'flex', flexDirection:'row', flexWrap:'wrap', alignItems:'center',
          backgroundColor: seleccionado === persona.id ? "lightblue" : null
        }}
        onClick={() => seleccionar(persona.id)}
      >

        <span><strong>{persona.documento} - </strong>{persona.nombre + ", " + persona.localidad}</span>
      </div>
    );
  }
}

export default class Gestion extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      loading:false,
      seleccionado:null
    }
  }

  componentDidMount(){}

  seleccionar(id){
    this.setState({seleccionado:id});
    this.props.seleccionar(id);
  }

  render(){
    const {seleccionado} = this.state;
    const {usuarios} = this.props;
    return(
      <div className="Todo Index" style={{width:'95%', marginTop:0, paddingTop:0}}>
        <div style={{
          width:'100%', display:'flex', flexDirection:'column',
          borderWidth:1, borderRadius:10, backgroundColor:'#ccc2b8', color:'black',
          overflowX:'hidden', height:600, overflowY:'scroll'
        }}>
          {usuarios.map((item, index) => {
            return(
              <span key={index}>
                <Persona
                  persona={item}
                  seleccionar={(id) => this.seleccionar(id)}
                  seleccionado={seleccionado}
                />
                {usuarios.length - 1 !== index &&
                  <hr style ={{margin:0, padding:0, color:'lightgrey'}}/>
                }
              </span>
            )
          })}
        </div>
      </div>
    );
  }
}
